import { useContext } from 'react'

import { ApplicationTemplateStoreContext } from '../../contexts'
import { ApplicationTemplateStore } from '../../types'

const useApplicationTemplateStore = (): ApplicationTemplateStore => {
   const applicationTemplateStore = useContext(ApplicationTemplateStoreContext)

   if (!applicationTemplateStore) {
      throw new Error(
         'Expected to be wrapped in Application Template Store Provider'
      )
   }

   return applicationTemplateStore
}

export { useApplicationTemplateStore }
